import { memo, useCallback } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import { WATCHLIST_GRID_REF, deepClone, getDecryptLocalStorage } from '../../utils/global_functions';
import { useDispatch, useSelector } from 'react-redux';
import { toastConfig } from '../../redux/actions/toast';
import { selectScripForDelete, updateCurrentWatchlist, updatedDashboardWatchlist } from '../../redux/actions/watchlist';
import { _removeSelectedScripts } from '../../controllers';
import { LOCAL_STORAGE_KEYS, NETWORK_RESPONSE_STATUS, GRID_VIEW } from '../../utils/global_variables';


const RemoveScripsConfirmationModal = ({ isToastToggle, activeWatchList, bIsShowDeleteCheckBox }) => {

    const modals = useSelector(state => state?.modals?.modals);
    const arrSelecedScripForDelete = useSelector(state => state?.watchList?.arrSelecedScripForDelete);
    const dashboardWatchlists = useSelector(state => state.watchList.dashboardWatchlists);
    const dispatch = useDispatch();
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    const strWatchlistView = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.WATCHLIST_VIEW);
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 
    const removeSlectedScrips = useCallback(() => {
        const activeWatchListCopy = deepClone(activeWatchList);
        const activeWatchListScripsCopy = activeWatchListCopy?.scrips;
        let selectedScrips = [];
        if (strWatchlistView === GRID_VIEW.DEFAULT_VIEW) {
            selectedScrips = WATCHLIST_GRID_REF?.current?.api?.getSelectedRows();
        } else if (strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW) {
            selectedScrips = arrSelecedScripForDelete;
        }
        const hanldeScripsRemoval = _removeSelectedScripts(activeWatchListCopy, activeWatchListScripsCopy, selectedScrips);


        if (!hanldeScripsRemoval.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cannot remove all scrip from ${activeWatchListCopy?.sWatchListName}` }));

            setTimeout(() => {
                dispatch(toastConfig({ show: true, message: hanldeScripsRemoval.message, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));
            }, 2000);
        } else {
            dispatch(updateCurrentWatchlist(hanldeScripsRemoval?.data?.objActiveWatchlist)).then(({ objResp, objWatchlistResp }) => {
                if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {// Ameersha N This will update scrips in dahsboard watchlist
                    if (dashboardWatchlists?.id === objResp?.data?.data?.id) {
                        dispatch(updatedDashboardWatchlist(objResp?.data?.data));
                    } else { }
                }
                //Ameersha N: 06-12-2023 :BT-95888 Breeze Create Watchlist --Start
                dispatch(handleModal([{ 'WATCHLIST_SCRIP_STATUS': true }]));
                //Ameersha N: 06-12-2023 :BT-95888 Breeze Create Watchlist --End


                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
                if (bIsShowDeleteCheckBox) {
                    //dispatch(handleModal([{ 'REMOVE_SCRIP_STATUS_MODAL': true }]));
                    dispatch(handleModalData({ data: { isRemoveScrip: true } }));
                    dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> 0</div> scrip from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));
                }
                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 

                else {
                    dispatch(toastConfig({}));
                }

                dispatch(selectScripForDelete([]));

            });
        }


    }, [dispatch, activeWatchList, isToastToggle, arrSelecedScripForDelete, bIsShowDeleteCheckBox, strWatchlistView]);




    const confirmRemove = () => {
        removeSlectedScrips();
        dispatch(handleModal([{ 'SCRIPS_REMOVE_CONFIRMATION_MODAL': false }]));
    };

    const cancelModal = () => {
        dispatch(handleModal([{ 'SCRIPS_REMOVE_CONFIRMATION_MODAL': false }]));
    };


    return (
        <BzModal size="sm" show={modals['SCRIPS_REMOVE_CONFIRMATION_MODAL']} onHide={cancelModal} id="TopModal" role="dialog" aria-hidden="true" centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0 align-items-center'>
                        <Col md={11}>
                            <div className='font-medium font-size4 color-text'>Remove Scrips</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={cancelModal} className='icon-16 icon-close icon-dark'></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <div className='font-regular font-size4 color-text'>
                                Are you sure you want to remove <span className='font-medium font-size3 color-text mx-1'>'{strWatchlistView === GRID_VIEW.PRICE_VOLUME_VIEW ? arrSelecedScripForDelete?.length : WATCHLIST_GRID_REF?.current?.api?.getSelectedRows().length}'</span> scrips from <span className='font-medium color-text mx-1'>'{activeWatchList?.sWatchListName}({activeWatchList?.scrips?.length})'</span>?
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter className='p-2'>
                <Container fluid className='p-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton data-testid="watchlist-scrip-remove-cnf-cancel" className='btn btn-md btn-block btn-outline me-2' onClick={cancelModal}>Cancel</BzButton>
                            <BzButton data-testid="watchlist-scrip-remove-cnf-remove" className='btn btn-md btn-block btn-primary ms-2' onClick={confirmRemove}>Remove</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(RemoveScripsConfirmationModal);